export default "__VITE_ASSET__CfOMk170__"